/**
 * @param {TimeInput} control1
 * @param {TimeInput} control2
 * @param {String} latestInput
 */
const fixBadRanges = function(control1, control2, latestInput) {
	const start = control1.val() || {}
	const end = control2.val() || {}
	// We can use lexical comparison in place of chronological comparison
	// because the times are always in 24-hour, zero-padded, zero-based format,
	// with the date portion, likewise, ordered by significance and padded to a
	// fixed field length.
	if (start && end && start > end) {
		control1.val(latestInput)
		control2.val(latestInput)
	}
}

/**
 * Takes two {TimeInput}s and watches for onSetDateTime events
 * between them in order to make sure the first control's value remains before the second
 * control's value chronologically.
 * @param {Array} controls DatasetsDateTimeFilterControls which are to be kept in chronological order
 * @param {Function} shouldFix a function which should return true/false depending
 * on if the controls should be kept in chronological order after any given onSetDateTime trigger
 */
const setupDateTimeRangeAutoFix = function(controls, shouldFix) {
	controls.forEach(it => {
		it.on('onSetDateTime', dt =>  {
			if (shouldFix(dt)) {
				fixBadRanges(controls[0], controls[1], dt)
			}
		})
	})
}

export default setupDateTimeRangeAutoFix
setupDateTimeRangeAutoFix.__filename__ = 'datasets/filters/setup-datetime-range-autofix.js'
